export default __webpack_public_path__ + "4553502eb7127b8d0eec0a24f7880876.svg";